var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vb-icon',{attrs:{"name":_vm.icon,"color":_vm.color,"size":_vm.size}})
}
var staticRenderFns = []

export { render, staticRenderFns }